import React, { Component } from 'react';
import { Control, Errors } from 'react-redux-form/immutable';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import classnames from 'classnames';

export class LabeledRadio extends Component {
  constructor(props) {
    super(props);
    this.id = `i${uuid()}`;
  }

  render() {
    const {
      model, label, value, readOnly,
    } = this.props;
    return (
      <div className="custom-control custom-radio haz-radio">
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <Control.radio
          model={model}
          value={value}
          id={this.id}
          name={value}
          aria-label={label}
          mapProps={{
            readOnly,
            className: ({ fieldValue }) => classnames({ 'custom-control-input': true, 'is-invalid': !fieldValue.valid }),
          }}
        />
        <label className="custom-control-label" htmlFor={this.id}>{label}</label>
        <Errors
          model={model}
          component="div"
          wrapper={({ children: childs }) => <div className="invalid-feedback">{childs}</div>}
        />
      </div>
    );
  }
}

LabeledRadio.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
};

LabeledRadio.defaultProps = {
  readOnly: false,
};
